import { axiosInstance } from ".";

const DASHBOARD_PATH = "/dashboard";

/** GET /api/admin_portal/v2/dashboard/overview (PROLINE-3755) — Super Admin only. */
const getAdminDashboardOverview = () =>
  axiosInstance.get(`${DASHBOARD_PATH}/overview`);

/** GET /api/admin_portal/v2/dashboard/quick_actions (PROLINE-3755) — Super Admin only. */
const getAdminDashboardQuickActions = () =>
  axiosInstance.get(`${DASHBOARD_PATH}/quick_actions`);

/**
 * GET /api/admin_portal/v2/dashboard/companies_overview (PROLINE-3826) —
 * approved companies with every dashboard figure. Query-string order is the
 * sort priority, so param order matters.
 */
const getAdminDashboardCompaniesOverview = (params = {}) =>
  axiosInstance.get(`${DASHBOARD_PATH}/companies_overview`, { params });

/**
 * GET /api/admin_portal/v2/dashboard/events_overview (PROLINE-3826) —
 * published events across the platform, each with its company. Query-string
 * order is the sort priority, so param order matters.
 */
const getAdminDashboardEventsOverview = (params = {}) =>
  axiosInstance.get(`${DASHBOARD_PATH}/events_overview`, { params });

export {
  getAdminDashboardOverview,
  getAdminDashboardQuickActions,
  getAdminDashboardCompaniesOverview,
  getAdminDashboardEventsOverview,
};
